import { useCallback, useEffect, useState } from 'react';
import { ShieldAlert } from 'lucide-react';
import toast from 'react-hot-toast';
import { PlayerFraudIndicatorsPanel } from '@kioskgaming/ui';
import AppLayout from '../components/layout/AppLayout';
import {
  fetchSuperAgentPlayerFraudIndicatorDetail,
  fetchSuperAgentPlayerFraudIndicators,
  fetchSuperAgentPlayerFraudWithdrawalAnalysis,
  fetchManagedAgents,
  fetchManagedShops,
  resolveSuperAgentPlayerFraudIndicator,
} from '../services/api';

export default function FraudIndicatorsPage() {
  const [shopOptions, setShopOptions] = useState<Array<{ id: string; name: string }>>([]);
  const [agentOptions, setAgentOptions] = useState<Array<{ id: string; name: string }>>([]);
  const onError = useCallback((msg: string) => toast.error(msg), []);
  const onSuccess = useCallback((msg: string) => toast.success(msg), []);

  useEffect(() => {
    Promise.all([fetchManagedAgents(), fetchManagedShops()])
      .then(([agentsRes, shopsRes]) => {
        const agents = (agentsRes.data || []) as Array<{ id: string; name: string }>;
        const shops = (shopsRes.data || []) as Array<{ id: string; name: string }>;
        setAgentOptions(agents.map((a) => ({ id: a.id, name: a.name })));
        setShopOptions(shops.map((s) => ({ id: s.id, name: s.name })));
      })
      .catch(() => {
        setAgentOptions([]);
        setShopOptions([]);
      });
  }, []);

  return (
    <AppLayout contentFullWidth>
      <div className="w-full max-w-none bg-slate-50/90 px-1 pb-8 sm:px-0">
        <header className="border-b border-slate-200/80 pb-4">
          <div className="flex items-center gap-2">
            <ShieldAlert className="h-5 w-5 text-orange-500" />
            <h1 className="text-lg font-semibold tracking-tight text-slate-900">Fraud indicators</h1>
          </div>
          <p className="mt-1 max-w-2xl text-sm text-slate-600">
            Player fraud flags across agents and shops in your hierarchy.
          </p>
        </header>
        <div className="mt-4">
          <PlayerFraudIndicatorsPanel
            fetchList={fetchSuperAgentPlayerFraudIndicators}
            fetchDetail={fetchSuperAgentPlayerFraudIndicatorDetail}
            fetchWithdrawalAnalysis={fetchSuperAgentPlayerFraudWithdrawalAnalysis}
            resolveIndicator={resolveSuperAgentPlayerFraudIndicator}
            showShopFilter
            showAgentFilter
            shopOptions={shopOptions}
            agentOptions={agentOptions}
            onError={onError}
            onSuccess={onSuccess}
          />
        </div>
      </div>
    </AppLayout>
  );
}
